import React, { createContext, ReactNode, useCallback, useContext, useEffect, useState } from 'react'

type RegisterBreadcrumbAction = (node: ReactNode | null) => () => void

const BreadcrumbActionStateContext = createContext<ReactNode | null>(null)
const BreadcrumbActionRegisterContext = createContext<RegisterBreadcrumbAction | null>(null)

export const BreadcrumbActionProvider = ({ children }: { children: ReactNode }) => {
  const [action, setAction] = useState<ReactNode | null>(null)

  const registerAction = useCallback((node: ReactNode | null) => {
    setAction(node)
    return () => setAction(null)
  }, [])

  return (
    <BreadcrumbActionRegisterContext.Provider value={registerAction}>
      <BreadcrumbActionStateContext.Provider value={action}>
        {children}
      </BreadcrumbActionStateContext.Provider>
    </BreadcrumbActionRegisterContext.Provider>
  )
}

export const useBreadcrumbAction = () => useContext(BreadcrumbActionStateContext)

export const useRegisterBreadcrumbAction = (node: ReactNode | null) => {
  const registerAction = useContext(BreadcrumbActionRegisterContext)

  useEffect(() => {
    if (!registerAction) return undefined
    return registerAction(node)
  }, [node, registerAction])
}

const BreadcrumbActions = () => {
  const action = useBreadcrumbAction()
  return action || null
}

export default BreadcrumbActions
